module.exports = __webpack_public_path__ + "6084db9f0aa59cb19cd8870d041d7831.svg";